import { render, staticRenderFns } from "./AddNotice.vue?vue&type=template&id=72e44562&scoped=true"
import script from "./AddNotice.vue?vue&type=script&lang=js"
export * from "./AddNotice.vue?vue&type=script&lang=js"
import style0 from "./AddNotice.vue?vue&type=style&index=0&id=72e44562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e44562",
  null
  
)

export default component.exports